/**
 * GRW-16's Log touchpoint with the person preselected (OD-92). The URL
 * contract is owned by GRW-16: /capture/{captureProjectId}?logTouchpoint=1&contact={contactId}.
 */ export function growthLogTouchpointHref(pursuitId, contactId) {
    const q = new URLSearchParams({
        logTouchpoint: '1',
        contact: contactId
    });
    return `/capture/${encodeURIComponent(pursuitId)}?${q.toString()}`;
}
/** Delivery's touchpoints page with the create form open (CustomerTouchpointsTab). */ export function deliveryLogTouchpointHref(programId, contactId) {
    const q = new URLSearchParams({
        logTouchpoint: '1',
        contact: contactId
    });
    return `/delivery/programs/${encodeURIComponent(programId)}/touchpoints?${q.toString()}`;
}
